<template>
    <div class="d-flex gap-3 h-100" style="">
        <div class="w-50">
            <h6 v-if="picklistTitle" class="mb-2">{{picklistTitle}}</h6>
            <Listbox 
                :value="value" 
                @input="handleListboxInput"
                :options="options" 
                :multiple="true" 
                :filter="true" 
                dataKey="id"
                optionLabel="full_name" 
                optionValue="id"
                optionDisabled="disabled"
                listStyle="height: 300px; max-height: 300px;" 
            >
                <template #option="slotProps">
                    <div class="d-flex gap-2 align-items-center">
                        <b-icon v-if="value.includes(slotProps.option.id)" key="isSelected" icon="check-circle-fill" variant="primary"></b-icon>
                        <b-icon v-else key="notSelected" icon="circle" variant="dark"></b-icon>
                        <span>{{slotProps.option.full_name}}</span>
                    </div>
                </template>
            </Listbox>
        </div>
        <div class="w-50 d-flex flex-column">
            <div class="mb-2 d-flex align-items-baseline justify-content-between">
                <h6 v-if="selectedTitle" class="mb-0">{{selectedTitle}}</h6>
                <span class="small text-muted">{{ value.length ? value.length : 'No' }} users</span>
            </div>
            
            <div class="flex-grow-1 p-3 bg-gray-100 border rounded">
                <div class="d-flex flex-row flex-wrap align-items-start gap-2">
                    <tenant-user-badge
                        v-for="tu in selectedTuObjects"
                        :key="tu.id"
                        :tu-data="tu"
                        deselectable
                        class="bg-white"
                        @deselect="handleDeselectAddTu(tu)"
                    ></tenant-user-badge>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Listbox from 'primevue/listbox';

// this is basically a form input, you can wrap it for various use-cases
// use v-model with array of TU IDs (uses :value and @input like normal v-model)

export default {
    name: 'TenantUserPicklist',
    components: {
        Listbox,
    },
    props: {
        value: {  // use v-model
            type: Array,
            default: () => [],
        },
        options: {  // should be array of TU objects
            type: Array,
            required: true,
        },
        picklistTitle: {
            type: String,
            default: 'Select Users:',
        },
        selectedTitle: {
            type: String,
            default: 'Selected Users:',
        },
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
        }
    },
    computed: {
        selectedTuObjects() {
            return this.options.filter(tu => this.value.includes(tu.id));
        },
    },
    mounted() {
    },
    methods: {
        // use this.apiErrorHandler(error, extraMsg, localMsg) from mixin - localMsg is bool, if true puts message in this.errorHandlingMessage

        emitInput(tuIds) {
            // just a DRY way of emitting input event to make v-model work
            this.$emit('input', [...tuIds]);
        },
        handleListboxInput(tuIds) {
            // arg will be new array of selected IDs - just emit copy of it
            this.emitInput(tuIds);
        },
        handleDeselectAddTu(tuObj) {
            // when user clicks deselect on a TU badge to deselect manually
            const tuIds = this.value.filter(tuId => tuId !== tuObj.id);
            this.emitInput(tuIds);
        },
    }
}
</script>

<style>

</style>